export default __webpack_public_path__ + "static/media/music-and-sound.420b0328.svg";